module.exports = __webpack_public_path__ + "static/5-26f31a34771873945acf8d8cb142a26b.jpg";